export default __webpack_public_path__ + "static/media/call-dashboard.92cbafa8.svg";